// extracted by mini-css-extract-plugin
export default {"casesContent":"PatienCasesPage_casesContent__0ryt2"};